export default __webpack_public_path__ + "media/shared/download-failed-new@3x-292cb5f7.png";